import apiService, { ApiService } from './ApiService';
import { apis } from '../utility/constants';
import {
  BillingCheckoutRequest,
  BillingCheckoutResponse,
} from '../types/checkout';
import {
  CheckoutReadyProductsResponse, InvoiceCreateRequest,
  InvoiceRequest,
  PaymentMethodRequestResponse
} from '../store/modules/billing/types';

class BillingService {
  private route = apis.billing;

  constructor(private api: ApiService) {}

  checkout = (payload: BillingCheckoutRequest) => this.api
    .post<BillingCheckoutResponse>(this.route.checkout(payload.user_id), payload);

  cancelPlan = (userId: number) => this.api.delete(this.route.plan(userId));

  getPaymentMethod = (userId: number) => this.api.get<PaymentMethodRequestResponse>(this.route.paymentMethod(userId));

  updatePaymentMethod = (userId: number, pmId: string) => this.api.put(this.route.paymentMethod(userId), {
    payment_method_id: pmId,
  });

  getInvoices = (payload: InvoiceRequest) => this.api.get(this.route.invoices(payload.userId), payload);

  createCustomInvoice = (payload: InvoiceCreateRequest) => this.api.post(this.route.createCustomInvoice(payload.user_id), payload);

  checkoutReadyProducts = (userId: number) => this.api
    .get<CheckoutReadyProductsResponse>(this.route.checkoutReadyProducts(userId));

  updatePromotionCodeInActiveSubscription = (userId: number, promotionCode: string) => this.api
    .put(this.route.updatePromotionCodeInActiveSubscription(userId), {
      user_id: userId,
      promotion_code: promotionCode,
    });
}

export default new BillingService(apiService);
